import { SelectColor } from 'components/colors/component'
import * as React from 'react'
import { Input } from 'reactstrap'
import { getConfiguration } from '../../utils'
import { TopicPreferencesLayoutAttributes } from '../constants'
import { EditSectionProps } from '../types'

export class CtaSettings extends React.Component<EditSectionProps> {
  constructor(props: EditSectionProps) {
    super(props)
  }

  public render() {
    return <div className="logo-size">
      <span className="title">{this.props.name}</span>
      <div className="section">
        <div className="block">
          <div className="title">Save Button</div>
          <div>
            <span>Button Text</span>
            <Input
              value={getConfiguration(this.props.data, TopicPreferencesLayoutAttributes.SaveButtonText, 'Save Preferences')}
              maxLength={50}
              onChange={(e) => {
                this.props.onChange(TopicPreferencesLayoutAttributes.SaveButtonText, e.target.value)
              }}
            />
          </div>
          <div style={{ marginTop: '1rem' }}>
            <span>Background Color</span>
            <SelectColor
              key={TopicPreferencesLayoutAttributes.SaveButtonBackgroundColor}
              className={'secondary'}
              selectColor={(c: string) => {
                this.props.onChange(TopicPreferencesLayoutAttributes.SaveButtonBackgroundColor, c)
              }}
              color={getConfiguration(this.props.data,
                TopicPreferencesLayoutAttributes.SaveButtonBackgroundColor, '#7FAE1B')}
            />
          </div>
          <div style={{ marginTop: '1rem' }}>
            <span>Text Color</span>
            <SelectColor
              key={TopicPreferencesLayoutAttributes.SaveButtonTextColor}
              className={'secondary'}
              selectColor={(c: string) => {
                this.props.onChange(TopicPreferencesLayoutAttributes.SaveButtonTextColor, c)
              }}
              color={getConfiguration(this.props.data,
                TopicPreferencesLayoutAttributes.SaveButtonTextColor, '#ffffff')}
            />
          </div>
        </div>
      </div>
    </div>
  }
}
